import * as React from 'react';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import { navigate } from '~/router';
import { createRouteNodeSelector } from 'redux-router5';
import { getOrgPaycodes, setPaycodeCurrentPage } from '../../actions/paycodes';
import { getPaycodeFilter } from '../../services/qsfilters';
import PaycodeListTable from '../../components/codes/PaycodeListTable';
import { defaultTablePageSize } from '~/common/components/consts';



class PaycodeList extends React.Component<any, any> {
  componentDidUpdate = (prevProps) => {
    if (prevProps.filter && this.props.filter) {
      if (!_.isEqual(prevProps.filter, this.props.filter)) {
        // TODO: Paging should be controlled by the component
        this.onFetchData({ page: 0, pageSize: defaultTablePageSize }, null);
      }
    }
  };

  onFetchData = (state, instance) => {
    const { dispatch, auth, paycodes, filter } = this.props;
    const orgId = auth.currentUser.organizationId;
    dispatch(getOrgPaycodes(orgId, filter, state.page * state.pageSize, state.pageSize));
  };

  onEditPaycode = (code) => {
    navigate('sender.paycodes.info', {paycodeId: code.id});
  };

  onReceipt = (code) => {
    const { transactions } = this.props;
    const transaction = code.transactionId && transactions[code.transactionId];

    if (transaction && transaction.receiptUrl) {
      window.open(transaction.receiptUrl);
    }
  };

  onPageChange = (page) => {
    const { dispatch } = this.props;

    dispatch(setPaycodeCurrentPage(page));
  };

  render() {
    const { paycodes, organizations, transactions } = this.props;

    return (
      <PaycodeListTable
        manual
        loading={paycodes.ui.loading}
        page={paycodes.ui.currentPage}
        data={paycodes.ui.currentList.map(c => paycodes.entities[c])}
        organizations={organizations}
        transactions={transactions}
        onFetchData={this.onFetchData}
        onEdit={this.onEditPaycode}
        onReceipt={this.onReceipt}
        onPageChange={this.onPageChange}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const selector = createRouteNodeSelector('sender');
  const { route: { params } } = selector(state);

  const filter = getPaycodeFilter(params);

  return {
    auth: state.shared.auth,
    paycodes: state.sender.paycodes,
    organizations: state.shared.organizations.entities,
    transactions: state.shared.transactions.entities,
    filter,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaycodeList) as any;
